import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import $ from 'jquery';

class Modal extends Component {

    constructor(props){
	super(props);
	this.close = this.close.bind(this);
	this.assignCallback = this.assignCallback.bind(this);
    }

    close(){
	$("#exampleModal").modal('toggle');
    }

    assignCallback(button){
	//{button.callback?(button.callback === 'close'?this.close:button.callBack):undefined}>
	if(button.close && button.close === true) this.close();
	if(button.callback) button.callback();
    }

    render() {
    	return (
		<div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="ModalTitleLabel" aria-hidden="true">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title" id="ModalTitleLabel">
							{this.props.modalContent && this.props.modalContent.title?this.props.modalContent.title:''}
						</h5>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div id="ModalBodyContent" className="modal-body">
						{this.props.modalContent && this.props.modalContent.body?this.props.modalContent.body.map((element,idx) => {
				 			return typeof element === 'object'? element:(<p key={'modal_body_'+idx}>{element} </p>)
						}):''}
					</div>
					<div id="ModalBodyFooter" className="modal-footer">
						{this.props.modalContent && this.props.modalContent.buttons?this.props.modalContent.buttons.map( (button,idx) => {
							return (<button type="button" key={"modal_btn_"+idx}
								className={button.behaviour === 'main'?"btn btn-primary":"btn btn-secondary"} 
								data-dismiss={button.close === true?"modal":undefined}
								onClick={this.assignCallback.bind(this,button)}>
									{button.shown}
								</button>)
						}):''}
					</div>
				</div>
			</div>
		</div>
        )
    }
}

const mapStateToProps = state => {
    return {
        modalContent: state.modalContent
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
            dispatch(setModalContent(modalContent));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal)
